import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n/i18n'; // i18next init (side-effect, must be before App)
import { App } from './App';
import './styles/globals.css';

createRoot(document.getElementById('root')!).render(
  <Suspense fallback={null}>
    <App />
  </Suspense>
);
